import React, {Component} from "react";
import "./Experience.css";

import ExperienceItem from "./ExperienceItem/ExperienceItem";

import colors from "colours";

export default class Experience extends Component
{
	render()
	{
		return (
			<div className="experience">
				<ExperienceItem
					company="OffToYou"
					position="Lead Web Developer"
					url="https://offtoyou.com"
					date="2013-2014"
					color={colors.SKILL1}
				/>

				<ExperienceItem
					company="SF Limo"
					position="Web Developer"
					url="http://sflimo.net"
					date="2014-2015	"
					color={colors.SKILL1}
				/>

				<ExperienceItem
					company="Piper"
					position="Web & Game Dev. Intern"
					url="https://buildpiper.com"
					date="2016-PRESENT"
					color={colors.SKILL3}
					caseStudy="/cases/Piper"
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Experience/Experience.js